import axios from "axios";
import CheckToken from "../../utils/checkToken/CheckToken";
import moment from "moment";

export const getTaxpayerListForCustomerCards = async (startDate, endDate) => {
  const token = await CheckToken();
  if (!token) {
    window.location.href = "/login";
  }

  return await axios.get(
    `${process.env.REACT_APP_API_URL}/customercard/get-taxpayer-list`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        startDate: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : undefined,
      },
    }
  );
};
